import { ButtonComponentProps } from "@omni/ui/components/Button/button.props";
import { ReactNode } from "react";
import { SheetDetent } from "react-modal-sheet";

import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useModalRouter } from "@/utils/hooks/useModalRouter";

import { Modal } from "./modal";

type Props = {
    modalType: ModalType;
    className?: string;
    sheetDetent?: SheetDetent;
    title: string | ReactNode;
    subtitle?: string | ReactNode;
    size?: "xs" | "sm" | "md" | "lg" | "xl";
    confirmButtonText?: string;
    confirmButtonColor?: ButtonComponentProps["color"];
    cancelButtonText?: string;
    closable?: boolean;
    formId?: string;
    isLoading?: boolean;
    isConfirmDisabled?: boolean;
    withFooter?: boolean;
    centered?: boolean;
    autoFocus?: boolean;
    scrollable?: boolean;
    onConfirm?: () => void;
    onCancel?: () => void;
    onOpenEnd?: () => void;
    onCloseEnd?: () => void;
    children?: ReactNode;
};

export const RouterModal = ({ modalType, children, ...modalProps }: Props) => {
    const { isOpen, isActive, toggle } = useModalRouter(modalType);

    return (
        <Modal
            {...modalProps}
            modalType={modalType}
            open={isOpen}
            active={isActive}
            setOpen={toggle}
        >
            {children}
        </Modal>
    );
};
